import { render, staticRenderFns } from "./pointsOrders.vue?vue&type=template&id=4ff4553c&"
import script from "./pointsOrders.vue?vue&type=script&lang=js&"
export * from "./pointsOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports